(() => {
  'use strict';

  if (window.__baywattProductFaqReady) return;
  window.__baywattProductFaqReady = true;

  const ITEM_SELECTOR = '.custom_faq_product_page';
  const HEAD_SELECTOR = `${ITEM_SELECTOR} > .head`;
  let sequence = 0;

  function directChild(item, selector) {
    return Array.from(item.children).find((child) => child.matches(selector)) || null;
  }

  function enhanceItem(item) {
    if (!(item instanceof HTMLElement)) return null;

    const head = directChild(item, '.head');
    const content = directChild(item, '.content');
    if (!head || !content) return null;

    if (item.dataset.baywattFaqReady === 'true') {
      return { item, head, content };
    }

    sequence += 1;
    const baseId = `BaywattProductFaq-${sequence}`;

    // Replace the legacy duplicate id="accordion-1" with unique relationships.
    item.id = baseId;
    head.id = `${baseId}-button`;
    content.id = `${baseId}-content`;

    if (head.tagName !== 'BUTTON') {
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
    }

    head.setAttribute('aria-expanded', 'false');
    head.setAttribute('aria-controls', content.id);
    content.setAttribute('role', 'region');
    content.setAttribute('aria-labelledby', head.id);
    content.hidden = true;
    content.style.display = 'none';

    item.classList.remove('is-open');
    head.classList.remove('active');
    head.querySelector('.arrow')?.classList.remove('arrow-animate');
    item.dataset.baywattFaqReady = 'true';

    return { item, head, content };
  }

  function setExpanded(parts, expanded) {
    const { item, head, content } = parts;
    const arrow = head.querySelector('.arrow');

    head.setAttribute('aria-expanded', String(expanded));
    item.classList.toggle('is-open', expanded);
    head.classList.toggle('active', expanded);
    arrow?.classList.toggle('arrow-animate', expanded);

    content.hidden = !expanded;
    // Inline display deliberately wins over the old #accordion-1 rule.
    content.style.display = expanded ? 'block' : 'none';
  }

  function toggleHead(head) {
    const item = head.closest(ITEM_SELECTOR);
    const parts = enhanceItem(item);
    if (!parts) return;
    setExpanded(parts, parts.head.getAttribute('aria-expanded') !== 'true');
  }

  function enhanceWithin(root = document) {
    if (root instanceof Element && root.matches(ITEM_SELECTOR)) enhanceItem(root);
    root.querySelectorAll?.(ITEM_SELECTOR).forEach(enhanceItem);
  }

  document.addEventListener('click', (event) => {
    const head = event.target.closest(HEAD_SELECTOR);
    if (!head) return;
    event.preventDefault();
    toggleHead(head);
  });

  document.addEventListener('keydown', (event) => {
    const head = event.target.closest(HEAD_SELECTOR);
    if (!head || head.tagName === 'BUTTON') return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    toggleHead(head);
  });

  document.addEventListener('shopify:section:load', (event) => enhanceWithin(event.target));

  const start = () => {
    enhanceWithin(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) enhanceWithin(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
